import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useWeekCalcs } from './hooks';

import './style.scss';

/**
 * @callback onChangeCb
 * @param {Moment} day
 */

/**
 * Calendar table header
 * @param {Moment} day
 * @returns {JSX.Element}
 * @constructor
 */
function CalendarTableHeader({ day, updateSort }) {
  const { calendar, getWeek } = useWeekCalcs(day);


  useEffect(() => {
    getWeek();
  }, [day, getWeek]);

  return (
    <div className="calendar_table_header">
      <div className="UnitsColumn unit_column">
        <div className="UnitsColumn__header">
          <div>Unit Information</div>
        </div>
      </div>
      <div className="weeks task_column">
        {calendar.map((d) => (
          <div key={d.format('D')} className={`weeks_day weeks_day_${['0', '6'].includes(d.format('d')) ? 'gray' : 'white'}`}>
            <div style={{ paddingTop: '10px' }}>{d.format('dd').toString()}</div>
            <div className="weeks_day_black" style={{ paddingTop: '13px' }}>
              {d.format('D').toString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

CalendarTableHeader.propTypes = {
  day: PropTypes.any,
  updateSort: PropTypes.func
};

export default React.memo(CalendarTableHeader);
